var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTruck = function SvgIconTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 6.5V6a1 1 0 0 0-1-1H2.25A1.75 1.75 0 0 0 .5 6.75v10.5A1.75 1.75 0 0 0 2.25 19h1.782a3.251 3.251 0 0 0 6.186 0h3.564a3.252 3.252 0 0 0 6.186 0h1.782a1.75 1.75 0 0 0 1.75-1.75v-6q0-.192-.072-.371l-1.31-3.277-.001-.003A1.74 1.74 0 0 0 20.49 6.5h.003v1l-.007-1h.004M2.5 7v5.5h13V7zm17.468 10H21.5v-4.75h-4v2.56A3.26 3.26 0 0 1 19.968 17M15.5 15.054V14.5h-13V17h1.532a3.251 3.251 0 0 1 6.186 0h3.564a3.26 3.26 0 0 1 1.718-1.946m2-4.804h3.523l-.7-1.75H17.5zm2.757-1.914.001.002zM7.125 16.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m9.75 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })));
};
export default SvgIconTruck;